import * as React from "react";
import { useTranslation } from "react-i18next";
import { IDistributorInfo } from "../shared/RestApi";

type Props = {
  distributorInfo: IDistributorInfo;
};

export function HowManyLicencesYouHaveMessage({ distributorInfo }: Props) {
  const { t } = useTranslation();

  if (distributorInfo.AvailableLicenses <= 0) {
    return <p>{t("licenses.noneAvailable")}</p>;
  }

  return (
    <p>
      {t("licenses.availableCount", {
        count: distributorInfo.AvailableLicenses,
      })}
    </p>
  );
}
